module.exports = __webpack_public_path__ + "assets/images/animal_g.6e97a0d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/animal_g.png
// module id = 675
// module chunks = 1